

import React from "react";
import FormDropdown from "../../components/FormDropdownUserOnline";

const DropdownView = ({
                          handleChange,
                          stateName,
                          label,
                          placeholder,
                          value,
                          disabled,
                          items
                      }) => (
    <div className="form-group row">

        <div className="col-md-5">
            <FormDropdown
                name={stateName}
                onChange={handleChange}
                items={items}
                value={value}
                disabled={disabled}
            />
        </div>
    </div>
);

export default DropdownView;


// WEBPACK FOOTER //
// ./src/views/Monitoring/DropdownView.js